import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/help-center/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/help-center/faq' });
  },
});
